import dynamicRoutesEntries from "@dynamic-routes";
import { Route, RouteEntry } from "@/interfaces/route";
import { sharedRoutesEntries } from "./shared";

const routesEntries = [...sharedRoutesEntries, ...dynamicRoutesEntries];

export const flatRoutes: Route[] = [];

function pushRoute(entry: RouteEntry, parent?: Route) {
  const route = <Route>entry;

  if ((route.auth?.inherit ?? true) && parent?.auth) {
    route.auth = parent.auth;
  }

  flatRoutes.push(route);

  if (parent && !isGroupSegment(parent.path)) {
    route.parent = parent;
  }

  return route;
}

function normalizePath(path: string) {
  return `/${path.replace(/^\//, "")}`.replace(/\/+/g, "/");
}

function isGroupSegment(path: string) {
  return path.startsWith("(");
}

function flattenRoutes(entries: RouteEntry[], parent?: Route) {
  entries.forEach((route) => {
    let parsedParent: Route | undefined;

    if (!isGroupSegment(route.path)) {
      let parentPath = "";

      if (parent && !isGroupSegment(parent.path)) {
        parentPath = normalizePath(parent.fullPath ?? parent.path ?? "");
      }

      route.path = normalizePath(route.path);
      route.fullPath = normalizePath(`${parentPath}${route.path}`);
      route.children = route.children ?? [];

      parsedParent = pushRoute(route, parent);
    }

    flattenRoutes(route.children ?? [], parsedParent);
  });
}

flattenRoutes(routesEntries);

export const routes = routesEntries as Route[];
